// client/src/components/public/PublicLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';
import ChatWidget from './ChatWidget';

const PublicLayout = () => (
    <div className="bg-white text-slate-800 flex flex-col min-h-screen">
        <PublicHeader />
        
        {/* Main content container with side columns */}
        <div className="flex-grow w-full max-w-screen-2xl mx-auto flex justify-center">
            {/* Left Side Column (visible on extra-large screens) */}
            <aside className="hidden xl:block w-1/6 bg-slate-50 border-r border-slate-200"></aside>

            {/* Center Content Area */}
            <main className="w-full xl:w-4/6 bg-white">
                <Outlet /> {/* Child page routes will render here */}
            </main>

            {/* Right Side Column (visible on extra-large screens) */}
            <aside className="hidden xl:block w-1/6 bg-slate-50 border-l border-slate-200"></aside>
        </div>

        <PublicFooter />
        {/* Website assistant: renders nothing unless switched on in Website Chat settings. */}
        <ChatWidget />
    </div>
);

export default PublicLayout;
